// src/utils/imageUrl.js
const BACKEND_BASE_URL =
  process.env.REACT_APP_BACKEND_URL || "https://roomvetiyo.com/api";

export function getImageUrl(path) {
  if (!path) return "";
  // if already full URL, just return it
  if (path.startsWith("http://") || path.startsWith("https://")) return path;
  // otherwise assume it's like "/uploads/rooms/..."
  return `${BACKEND_BASE_URL}${path}`;
}
